module.exports = __webpack_public_path__ + "assets/img/banner-center4.7a57a9b2.jpg";